export enum Route {
  home,
  forBrokers,
  forOperators,

  // гостевые роуты
  price,
  agents,
  legalDocuments,
  airportData,

  // авторизация и логин
  login,
  register,
  setNewPassword,

  // роут личного кабинета
  lk,

  // общие роуты ЛК
  profile,
  settings,
  messageTemplates,
  subscription,

  // лк фрахтователя
  newTripRequest,
  searchEmptyLegs,
  requests,
  requestsFromClients,

  // лк фрахтовщика
  fleet,
  requestsFromAgents,
  emptyLegs,
  // tripBoard,
  schedule,
  scheduleNew,
  schedulePrivate,
  schedulePublic,
  eventCalendar,

  // лк админа сайта
  adminRegistrations,
  adminPlaneApprovals,
  adminCurrencies,

  // 404
  notFound,
}